export const environment = {
  production: false,
  ENV_NAME: 'staging',

  // Stripe Configuration
  STRIPE_PUBLISHABLE_KEY: 'pk_test_51IfoiWHNS7vXL7339UlPEUzGXu7fCC50Yc2ijKZNC3dYnN7o31h4sOaF1Msvp0yx9t03JLM3qltAzFcH04BCTY0200zLl69p78', // TODO: Replace with your actual Stripe publishable key

  UPLOADS_BASE_URL: 'https://automonkey-uploads-staging.s3.us-east-2.amazonaws.com/',
  CHAT_IMAGE_BASE_URL: 'https://automonkey-uploads-staging.s3.us-east-2.amazonaws.com/job_chat_image/',
  BASE_URL: 'https://admin-staging.theautomonkey.com/',
  HOST: 'hrhg5ktsd2.us-east-2.awsapprunner.com',
  //HOST: 'localhost:3002',
  //API_URL: 'http://localhost:3002/',
  API_URL: 'https://hrhg5ktsd2.us-east-2.awsapprunner.com/',

  ONESIGNAL_APPID: '5852c380-adec-456e-81df-0cc0bbcf4365',
  ONESIGNAL_GOOGLE_NUMBER: '703322744261',
  PUSHER_KEY: 'd4255351238767cbd61b',
  PUSHER_CLUSTER: 'mt1',
  POSTHOG_KEY: 'phc_evYwZyLWapCRlnW7Vy9FNOUEkPCU10FHE1QjuiWSY71',
  POSTHOG_HOST: 'https://us.i.posthog.com',
  // Staging-all Betterstack source — the prod token lives in environment.prod.ts
  // (this file is the staging web build; it was logging into mobile-app-prod).
  LOGTAIL: '4fLNb8ifwErjaFP3SRFTpC6c',

  // Social login (Google + Apple). Empty = that button is hidden on that
  // platform until the id is configured. Google ids live in the automonkey
  // Google Cloud project (Firebase automonkey-a8b2d); the web client id must be
  // created there and its origins must include this build's host.
  SOCIAL_LOGIN: {
    // Feature flag: false hides every social button regardless of client ids.
    ENABLED: false,
    GOOGLE_WEB_CLIENT_ID: '452774378253-vu7npu8o1khaqmasirhbhprq9pkasvrj.apps.googleusercontent.com',
    // iOS client for bundle id com.autoMonkeyDistributionProfile (Xcode) — the
    // Android package is com.automonkeyapp. Reversed form = Info.plist URL scheme.
    GOOGLE_IOS_CLIENT_ID: '452774378253-n8bqmrp0oj0ivholcohkr2pv1vg5iqar.apps.googleusercontent.com',
    APPLE_CLIENT_ID: 'com.autoMonkeyDistributionProfile',
    // Web Sign in with Apple needs a Services ID + a registered return URL.
    APPLE_WEB_SERVICE_ID: 'com.autoMonkeyDistributionProfile.web',
    APPLE_WEB_REDIRECT_URL: '', // empty = <current origin>/login; every host must be a Services ID return URL
  },
};
